module.exports = __webpack_public_path__ + "img/AutomateAppointments.cd0af636.svg";